<div class="flex-align-center flex-space-between pad-M" style="border-radius: 10px;">
	<div class="font-MM fw-700 primary">{{ 'menu.usage'|translate }}</div>
	<app-toggle-button
		[toggleInput]="usageActivatedControl"
		[locked]="usageActivatedControl.disabled"
		[tooltipDisabled]="usageActivatedControl.enabled"
		tooltipPosition="bottom"
		[tooltipOffset]="5"
		[tooltip]="'page.appDetails.settings.usageToggleTooltip' | translate"></app-toggle-button>
</div>
<div class="pad-M" style="padding-top: 0;">
	<form *ngIf="!_initializing" class="flex-column gap-S">
		<div class="flex-column gap-XS">
			<span>{{ 'page.appDetails.settings.usageFirstLine'|translate }}</span>
			<span>{{ 'page.appDetails.settings.usageSecondLine'|translate }}</span>
			<span>{{ 'page.appDetails.settings.usageThirdLine'|translate }}</span>
		</div>
		<div class="flex-align-center gap-S mb-xs">
			<img src="assets/icons/attention.svg" height="14" width="14" alt=""/>
			<div class="orange-text">
				<span>{{ 'page.appDetails.settings.attention1'|translate }}</span>
				<a (click)="goToSettings()" class="link"
				   style="text-decoration: underline">{{ 'page.appDetails.settings.attention2'|translate }}</a>
				<span>{{ 'page.appDetails.settings.attention3'|translate }}</span>
			</div>
		</div>
		<div class="hr-document"></div>
		<div class="flex-align-center flex-space-between">
			<div class="flex-align-center gap-XS mt-xs mb-s">
				<span class="font-MM fw-700 primary">{{ 'page.appDetails.settings.webUsage'|translate }}</span>
				<div class="flex-center" style="height: 25px; width: 25px;"
					 [tooltip]="'page.appDetails.settings.webUsageTooltip'|translate" tooltipPosition="right"
					 [tooltipOffset]="5">
					<img src="assets/icons/help-2.svg" class="info-bubble" width="14"
						 height="14"
						 alt=""/>
				</div>
			</div>
			<span class="accent c-p underlined-hover" (click)="addNewUrl()">{{'page.appDetails.settings.addAUrl'|translate}}</span>
		</div>
		<!-- URL entries section -->
		<div class="flex-column gap-M">
			<div *ngFor="let urlControl of usageUrlsControl.controls; let i = index">
				<div class="flex-align-center gap-M">
					<div class="flex-column w-40 p-relative">
						<div class="grey fw-500">{{'page.appDetails.settings.usageDomain'|translate}}</div>
						<app-text-input [placeholder]="'page.appDetails.domainPlaceholder'|translate"
										[input]="$any(urlControl.get('domain'))"
										(keyup.enter)="urlControl.updateValueAndValidity()">
						</app-text-input>
						<span [style.opacity]="$any(urlControl.get('domain')).valid ? 0 : 1" style="bottom: -18px;width: 100%;" class="text-red text-right p-absolute font-S">
							{{'page.appDetails.settings.invalidFormat'|translate}}
						</span>
					</div>
					<div class="flex-column w-100">
						<div class="grey fw-500">{{'page.appDetails.settings.usagePath'|translate}}</div>
						<div class="flex-align-center gap-XS">
							<div class="flex-center w-100">
								<div class="flex-center slash">/</div>
								<app-text-input class="w-100" [placeholder]="'page.appDetails.pathPlaceholder'|translate"
												[input]="$any(urlControl.get('path'))"
												[leftBorder]="false"
												(keyup.enter)="urlControl.updateValueAndValidity()">
								</app-text-input>
							</div>
							<app-icon-button *ngIf="usageUrlsControl.length > 1" color="danger" size="s" [img]="'assets/icons/trash.svg'"
											 [tooltip]="'button.delete' | translate"
											 (click)="removeUrl(i)">
							</app-icon-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="hr-document mt-m"></div>
		<div class="flex-align-center flex-space-between mt-xs mb-s">
			<div class="flex-align-center gap-XS">
				<span class="font-MM fw-700 primary">{{ 'page.appDetails.settings.agentUsage'|translate }}</span>
				<div class="flex-center" style="height: 25px; width: 25px;" tooltip
					 [tooltipTriggerFor]="agentUsageTooltip" tooltipPosition="right" [tooltipOffset]="5">
					<img src="assets/icons/help-2.svg" class="info-bubble" width="14"
						 height="14"
						 alt=""/>
				</div>
				<app-tooltip #agentUsageTooltip>
					<div style="width: 200px">
						<span style="white-space: pre-wrap">
							{{ 'page.appDetails.settings.agentUsageTooltip'|translate }}
						</span>
					</div>
				</app-tooltip>
			</div>
			<span class="accent c-p underlined-hover"
				  (click)="addNewDesktopApplicationName()">{{ 'page.appDetails.settings.addMoreName'|translate }}</span>
		</div>
		<div class="flex-column gap-M">
			<div *ngFor="let desktopApplicationNameControl of desktopApplicationNamesControl.controls; let i = index">
				<div class="grey fw-500">{{ 'page.appDetails.settings.nameToTarget'|translate }}</div>
				<div class="flex-align-center gap-XS">
					<app-text-input class="w-100"
									[placeholder]="'Kabeen'"
									[input]="desktopApplicationNameControl"
									(blur)="desktopApplicationNameControl.updateValueAndValidity()"
									(keyup.enter)="desktopApplicationNameControl.updateValueAndValidity()">
					</app-text-input>
					<app-icon-button *ngIf="desktopApplicationNamesControl.length > 1" color="danger" size="s" [img]="'assets/icons/trash.svg'"
									 [tooltip]="'button.delete' | translate"
									 (click)="removeDesktopApplicationName(i)">
					</app-icon-button>
				</div>
			</div>
		</div>
	</form>
</div>
